<div [formGroup]="documentForm()">
  <h2 class="tooltip-heading-label">
    {{ certificateLabel() | translate }}
    @if (isCertificateMandatory()) {
      <span>*</span>
    }
    <app-info-tooltip
      [tooltipText]="certificateLabel() + '_TOOLTIP' | translate"
    />
  </h2>
  <span
    [innerHTML]="'ZEREZ.DESCRIPTION' | translate"
    class="document-description"
  >
  </span>
  <div class="space"></div>

  <div [formArrayName]="certificateName()" class="two-column-layout-container">
    @for (
      zerezId of zerezIdsFormArray.controls;
      track zerezId;
      let i = $index
    ) {
      <div class="two-column-layout-item">
        <div class="input-field-with-postfix-container">
          <mat-form-field appearance="outline" class="input-field-with-postfix">
            <mat-label>{{ "ZEREZ.INPUT_PLACEHOLDER" | translate }}</mat-label>
            <input
              [name]="'zerezId' + i"
              [formControlName]="i"
              [attr.data-testid]="certificateName() + 'zerez-id-' + i"
              matInput
              type="text"
            />
            <mat-error [appErrorMessages]="'' + i" />
          </mat-form-field>
          <button
            (click)="deleteZerezId(i)"
            [disabled]="i === 0"
            [attr.data-testid]="
              certificateName() + 'delete-zerez-id-' + i + '-button'
            "
            type="button"
            mat-icon-button
            class="input-field-postfix"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>
  <button
    (click)="addZerezId()"
    [disabled]="zerezIdsFormArray.length | exceedsLimit"
    [attr.data-testid]="certificateName() + 'add-zerez-id-button'"
    type="button"
    mat-stroked-button
  >
    <mat-icon>add</mat-icon>
    {{ "ZEREZ.ADD_ZEREZ_ID" | translate }}
  </button>
</div>
<div class="space"></div>
